import { useRef } from "react";

import { Button } from "ui/Button/Button";
import { Modal } from "ui/Modal/Modal";
import { TIME_PICKER_WIDTH_NUMBER, TimePicker } from "ui/TimePicker/TimePicker";

export type TimePickerModalProps = {
  onClickConfirm: (newDate: string) => void;
  onClickCancel: () => void;
  confirmLabel: string;
  cancelLabel: string;
  isOpen: boolean;
  /**
   * initialValue: expected format : "hh:mm"
   */
  initialValue?: string;
};

export function TimePickerModal({
  onClickConfirm,
  onClickCancel,
  isOpen,
  confirmLabel,
  cancelLabel,
  initialValue = new Date().toLocaleTimeString("de-DE").slice(0, 5),
}: TimePickerModalProps) {
  const currentTimeRef = useRef(initialValue);

  return (
    <Modal
      trapFocus={false}
      closeOnOverlayClick={false}
      isCentered
      isOpen={isOpen}
      onClose={() => {}}
    >
      <Modal.Content maxW={TIME_PICKER_WIDTH_NUMBER + 32}>
        <Modal.Body p="s200">
          <TimePicker
            onChange={(newDate) => {
              currentTimeRef.current = newDate;
            }}
            initialValue={currentTimeRef.current}
          />
        </Modal.Body>
        <Modal.Footer paddingX="s200" paddingTop="0" flexDir="column">
          <Button
            onClick={() => onClickConfirm(currentTimeRef.current)}
            variant="primary"
            size="lg"
            isFullWidth
          >
            {confirmLabel}
          </Button>
          <Button mt="s100" onClick={onClickCancel} variant="secondary" size="lg" isFullWidth>
            {cancelLabel}
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
}
